export const networkDashboard = {
    NETWORK_DASHBOARD_PENDING  : 'NETWORK_DASHBOARD_PENDING',
    NETWORK_DASHBOARD_FULFILLED: 'NETWORK_DASHBOARD_FULFILLED',
    NETWORK_DASHBOARD_REJECTED : 'NETWORK_DASHBOARD_REJECTED',
};
